import { render, staticRenderFns } from "./Cash_register.vue?vue&type=template&id=0bb29b74&scoped=true"
import script from "./Cash_register.vue?vue&type=script&lang=js"
export * from "./Cash_register.vue?vue&type=script&lang=js"
import style0 from "./Cash_register.vue?vue&type=style&index=0&id=0bb29b74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb29b74",
  null
  
)

export default component.exports